// extracted by mini-css-extract-plugin
export default {"page":"BW-z","cartModal":"CW-z","checkout":"DW-z","placeholder":"EW-z","account":"FW-z"};